import { cva } from 'class-variance-authority'

export const cardVariants = cva('rounded-lg transition-all', {
  variants: {
    variant: {
      default: 'bg-bg-elevated border border-border-default',
      outline: 'border-2 border-border-default bg-transparent',
      ghost: 'bg-bg-subtle',
      primary: 'bg-primary text-primary-fg border-none',
      secondary: 'bg-secondary text-secondary-fg border-none',
    },
    padding: {
      none: 'p-0',
      sm: 'p-3',
      default: 'p-4',
      lg: 'p-6',
      xl: 'p-8',
    },
    shadow: {
      none: 'shadow-none',
      sm: 'shadow-sm',
      default: 'shadow-md',
      lg: 'shadow-lg',
      xl: 'shadow-xl',
    },
    hoverable: {
      true: 'cursor-pointer hover:shadow-lg hover:border-border-strong transition-all duration-200',
      false: '',
    },
  },
  defaultVariants: {
    variant: 'default',
    padding: 'default',
    shadow: 'default',
    hoverable: false,
  },
})
